import { PanelDesignTokens } from "@primeuix/themes/types/panel";
import { PanelPassThrough } from "primeng/panel";

export const panel: PanelDesignTokens = {
    extend: {
        roundPanel: {
            borderRadius: "4px",
        },
        roundExpandedPanel: {
            headerBorderRadius: "4px 4px 0 0",
            contentBorderRadius: "0 0 4px 4px",
        },
    },
    css: ({ dt }) => {
        /**
         * Base Panel Styles
         */
        const base = `
            .p-panel {
                border: none;
            }
        `;

        /**
         * Round Panel Styles
         * Usage: apply .p-panel__round to p-panel;
         *        apply .p-panel__round--expanded to p-panel if panel is expanded
         */
        const rounded = `
            .p-panel.p-panel__round, .p-panel.p-panel__round .p-panel-header {
                border-radius: ${dt("panel.round.panel.border.radius")};
            }
        `;

        const roundExpanded = `
            .p-panel.p-panel__round--expanded {
                border-radius: ${dt("panel.round.panel.border.radius")};
            }

            .p-panel.p-panel__round--expanded .p-panel-header {
                border-radius: ${dt("panel.round.expanded.panel.header.border.radius")};
            }

            .p-panel.p-panel__round--expanded .p-panel-content {
                border-radius: ${dt("panel.round.expanded.panel.content.border.radius")};
            }
        `;

        return base + rounded + roundExpanded;
    },
};

export const panelPt: PanelPassThrough = {
    pcToggleButton: {
        root: {
            style: {
                background: "transparent",
            },
        },
    },
};
